import { SpinnerLegacy } from "../../../../components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import { useOrderEventList } from "../../../../hooks/api/v2/orderEvent/useOrderEventList";
import { OrderEventListDialogItem } from "./OrderEventListDialogItem";

type OrderEventListDialogProps = {
  active: boolean;
  onDismiss: () => void;
  orderId: number;
};

export const OrderEventListDialog = (props: OrderEventListDialogProps) => {
  return (
    <Dialog active={props.active} onDismiss={props.onDismiss}>
      <OrderEventListDialogContent {...props} />
    </Dialog>
  );
};

const OrderEventListDialogContent = ({
  orderId,
  onDismiss,
}: OrderEventListDialogProps) => {
  const orderEventListQuery = useOrderEventList({
    query: [
      {
        type: "OrderId",
        modifier: "EQUALS",
        value: orderId,
      },
    ],
    sortBy: "createdAt",
    sortDir: "desc",
  });

  return (
    <>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Order history"}
      />
      <DialogContent className={"flex w-full flex-col gap-2 px-8 pb-8"}>
        {orderEventListQuery.isPending ? (
          <SpinnerLegacy />
        ) : (
          <>
            {orderEventListQuery.data?.pages.map((page) => (
              <>
                {page.map((event, i) => (
                  <OrderEventListDialogItem key={i} event={event} />
                ))}
              </>
            ))}
          </>
        )}
      </DialogContent>
    </>
  );
};
